"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    Amount: 'i128',
    AmountOf: 'Amount',
    Rate: 'FixedU128',
    Ratio: 'Permill',
    Timestamp: 'u64',
    PriceDetail: '(Price, Timestamp)',
    CurrencyId: 'AssetId',
    CurrencyIdOf: 'CurrencyId',
    Currency: 'CurrencyId',
    AssetIdOf: 'AssetId'
  }
};
exports.default = _default;